<template>
<div class="flowTopPart">
    <div class="topList">
        <div :class="setClass(item, index)" 
            v-for="(item,index) in secondTopStepArr" 
            v-show="!('show' in item)||item.show" 
            :key="index" 
            @click="$emit('topItemClick',index)">
            <div class="normalBox">
                <span class="stepArrow el-icon-arrow-right"></span>
                <div class="mainBox">
                    <div class="stepIcon">
                         <span  class="icon" >
                                <i v-if = "isHasClass('activeClass', item, index)"  class = "el-icon-edit"/>
                                <i v-else-if = "isHasClass('is-success', item, index)"  class = "el-icon-check" />
                                <!-- <i v-else-if = "isHasClass('is-wait', item, index)"  class = "el-icon-wait" /> -->
                                <div v-else class="el-icon-wait">{{index+1}}</div>
                                <!-- <i v-else-if = "isHasClass('pageReject', item, index)"  class = "el-icon-reject" /> -->
                         </span>
                        
                    </div>
                    <div class="title">{{item.name||item.IMG_CLS_NAME}}</div>
                </div>
            </div>
            <div class="rejectTxt" v-if="item.status=='reject'">（驳回）</div>
        </div>
    </div>
</div>
</template>

<script>

export default {
  data () {
    return {};
  },
  components: {
  },
  computed: {
    stepName (){
      return this.$router.getCurrentRoute().name;
    },
        
  },
  props: ["bizTopIndex","secondTopStepArr"],
  methods: {
    setClass (item, index) {
      let classArr = [
        {"activeClass":item.name == this.stepName},
        {"is-success":item.status=="success" || item.stepIndex < this.bizTopIndex},
        {"is-wait": !item.status && item.stepIndex > this.bizTopIndex},
        {"pageReject":item.status=="reject"},
        {"is-prev-item":item.stepIndex < this.bizTopIndex},
        {"is-next-item":item.stepIndex > this.bizTopIndex},
        "stepBox"
      ];
      return classArr;
    },
    isHasClass (type,item, index) {
      return !!_.find(this.setClass(item, index) || [], obj=> !!obj[type]);
    }
  },
};
</script>

<style lang="less">
.flowTopPart{
    width: 100%;
    position: absolute;
    left: 0;
    top:0px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background: #ffffff;
    padding: 0.20rem 0;
    border-radius: 5px;
    margin-bottom: 2px;
    height: 0.6rem;
    border-bottom: 2px solid #e9ebee;
    .topList{
        // overflow-x:scroll;
        display:flex;
        .stepBox{
          
            .normalBox{
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: relative;
                .mainBox{
                    position: relative;
                    display: flex;
                    align-items: center;
                    z-index: 1;
                    max-width: 165px;
                    .stepIcon{
                        margin-right: 5px;
                        width: 20px;
                        height: 20px;
                        border-radius: 20px;
                        font-size: 14px;
                        text-align: center;
                        line-height: 20px;
                        color: #fff;
                        background: white;
                        border: 1PX solid #d0aa72;
                        box-sizing: content-box;
                        .el-icon-wait {
                            display:inline-block;
                            width: 20px;
                            height: 20px;
                            border-radius: 50%;
                            // border: 1Px solid;
                            border-color: inherit;
                            color: #ccc;
                            // background: url('../../icons/red/step/icon-step-flow-wait.svg') no-repeat center center;
                        }
            
                    }
                    .title{
                        font-size: 14px;
                        color: #9A9A9A;
                        height: 20px;
                        line-height: 20px;
                        word-break: break-all;
                    }
                }
                .stepArrow{
                    margin: 0 27px;
                    font-size: 14px;
                    font-weight: bold;
                    color: #b1b1b1;
                }
            }
            &.is-wait {

                .normalBox .mainBox .title {
                    color: #b9b9b9;
                }
                .normalBox .mainBox .stepIcon {
                    background:#fff;
                    border: 1px solid #ccc;
                }
                .normalBox .stepArrow {
                    //  border-bottom: 2px solid #c6c6c6;
                }
            }
            &.is-success {
                .normalBox .mainBox {
                    .stepIcon {
                        // background: #ff8383;
                        // border-color: #D0AA72;
                        // background: #D0AA72;
                        background: white;
                        border: 1px solid #d0aa72;
                        color: #d0aa72;
                    }
                    .title,.stepArrow {
                        color: #D0AA72;
                    }
                }
            }
            &.activeClass {
                 .normalBox .mainBox {
                    .stepIcon {
                        // background: red;
                        // border-color:red;
                        border-color: #D0AA72;
                        background: #D0AA72;
                    }
                    .title {
                        color: #222;
                    }
                 }
            }
            &.is-next-item {
                &.is-success {
                   
                     .normalBox .mainBox {
                        .stepIcon {
                            background: #ff8383;
                        }
                        .title {
                            color: #ff8383;
                        }
                    }
                }
            }
            &:first-child {
                .stepArrow {
                    display:none;
                }
            }
        }
    }
    .buttonBox{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        text-align: center;
        .el-button{
            width: 185px;
            height: 46px;
            background-color: #587ef7;
            border:0;
            border-radius: 23px;
            margin-bottom: 16px;
            text-align: center;
            color: #fff;
            font-size: 22px;
        } 
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/bizflowTop.vue